import { useRealTimeStore } from '@hotjar/webapp/features/Playbacks/store/realTimeStore';
import { Store } from '../../../store/player/types';
import { jumpTo } from './jumpTo';

/**
 * Rewind the recording by a preset amount.
 */
export const rewind = (store: Store, ms: number): void => {
  const currentTime = useRealTimeStore.getState().currentTime;

  if (currentTime > 0) {
    jumpTo(store, Math.max(currentTime - ms, 0));
  }
};
